import { AUDIT_LOGS_VIEWER, COMPANY_VIEW, DASHBOARD_VIEWER, GROUP_CREATION, LOOKUP_VIEW, REPORT_DEFAULTS_VIEW, REPORT_VIEW, ROLE_VIEW, SITE_VIEW, USER_REPORTS, USER_VIEW, } from "./../../../core/constants/permissionConstants";
import { faChartBar, faTable } from "@fortawesome/free-solid-svg-icons";
import { DashboardType } from "../../../core/enums/dashboardType";
import localize from "../../../core/utils/translation-files";
import { treeMenuType } from "../../../core/enums/treeMenuType";
export const sidebarActions = {
    [DashboardType.Admin]: [
        {
            title: localize(["DashboardMenus.mainMenu"]),
            requiredPermissions: [DASHBOARD_VIEWER],
            order: 1,
            children: [
                // {
                //   title: localize(["DashboardMenus.dashboard"]),
                //   routing: "dashboard",
                //   svgIcon: "DashboardMenuSvg",
                //   requiredPermissions: [DASHBOARD_VIEWER],
                //   order:1,
                // },
                {
                    title: localize(["DashboardMenus.home"]),
                    routing: "landing-page",
                    icon: faChartBar,
                    svgIcon: "DashboardMenuSvg",
                    requiredPermissions: [DASHBOARD_VIEWER],
                    order: 13,
                },
                {
                    title: localize(["DashboardMenus.my", "DashboardMenus.watchList"]),
                    routing: "watchlist",
                    svgIcon: "WatchlistMenuSvg",
                    requiredPermissions: [DASHBOARD_VIEWER],
                    order: 15,
                },
                {
                    title: localize(["DashboardMenus.overview"]),
                    routing: "dashboard",
                    svgIcon: "OverviewNavSvg",
                    requiredPermissions: [DASHBOARD_VIEWER],
                    order: 20,
                },
                {
                    title: localize(["DashboardMenus.reports"]),
                    routing: "reports",
                    svgIcon: "ReportsNavSvg",
                    order: 30,
                    requiredPermissions: [USER_REPORTS],
                },
                {
                    title: localize(["DashboardMenus.notifications"]),
                    adminTitle: localize(["DashboardMenus.notifications"]),
                    routing: "notifications-events",
                    svgIcon: "NotificationsNavSvg",
                    order: 40,
                    requiredPermissions: [],
                },
            ],
        },
        {
            title: localize(["DashboardMenus.administration"]),
            requiredPermissions: [DASHBOARD_VIEWER],
            order: 2,
            children: [
                {
                    title: localize(["manage", "Group.groups"]),
                    adminTitle: localize(["manage", "DashboardMenus.my", "Group.groups"]),
                    routing: "groups",
                    svgIcon: "GroupNavSvg",
                    order: 60,
                    requiredPermissions: [GROUP_CREATION],
                    status: treeMenuType.collapse,
                    isExpandableDefault: true,
                    sub: [
                        {
                            title: localize(["manage", "Company.companies"]),
                            adminTitle: localize([
                                "manage",
                                "DashboardMenus.my",
                                "Company.companies",
                            ]),
                            routing: "companies",
                            // svgIcon: "CompanyMenu",
                            requiredPermissions: [COMPANY_VIEW],
                            status: treeMenuType.collapse,
                            isExpandableDefault: true,
                            sub: [
                                {
                                    title: localize(["manage", "Site.sites"]),
                                    adminTitle: localize([
                                        "manage",
                                        "DashboardMenus.my",
                                        "Site.sites",
                                    ]),
                                    routing: "sites",
                                    // svgIcon: "SiteMenu",
                                    requiredPermissions: [SITE_VIEW],
                                },
                            ],
                        },
                    ],
                },
                {
                    title: localize(["manage", "User.users"]),
                    adminTitle: localize(["manage", "DashboardMenus.my", "User.users"]),
                    routing: "users",
                    svgIcon: "UserNavSvg",
                    order: 70,
                    requiredPermissions: [USER_VIEW],
                },
                {
                    title: localize(["manage", "Role.roles"]),
                    routing: "roles",
                    svgIcon: "RoleNavSvg",
                    order: 80,
                    requiredPermissions: [ROLE_VIEW],
                },
                {
                    title: localize(["manage", "Lookup.lookups"]),
                    routing: "lookups",
                    icon: faTable,
                    svgIcon: {
                        active: "ActiveLookupMenu",
                        inActive: "InActiveLookupMenu",
                    },
                    order: 110,
                    requiredPermissions: [LOOKUP_VIEW],
                },
                {
                    title: localize(["DashboardMenus.manageOdis"]),
                    adminTitle: localize([
                        "manage",
                        "DashboardMenus.my",
                        "TrackedItem.trackedItems",
                    ]),
                    routing: "manage-client-tracked-items",
                    requiredPermissions: [REPORT_VIEW],
                    svgIcon: "ManageOdiNavSvg",
                    order: 90,
                },
                {
                    title: localize(["TrackedItem.odiDirectory"]),
                    adminTitle: localize(["TrackedItem.odiDirectory"]),
                    routing: "manage-tracked-item-defaults",
                    requiredPermissions: [REPORT_DEFAULTS_VIEW],
                    svgIcon: "OdiDirectoryNavSvg",
                    order: 100,
                },
                {
                    title: localize(["manage", "DashboardMenus.notifications"]),
                    routing: "notifications",
                    svgIcon: "ManageNotificationNavSvg",
                    order: 120,
                    requiredPermissions: [SITE_VIEW],
                },
            ],
        },
        {
            title: localize(["DashboardMenus.options"]),
            order: 3,
            requiredPermissions: [DASHBOARD_VIEWER],
            children: [
                {
                    title: localize(["DashboardMenus.auditLogs"]),
                    routing: "audit-logs",
                    svgIcon: "AuditLogNavSvg",
                    order: 130,
                    requiredPermissions: [AUDIT_LOGS_VIEWER],
                },
            ],
        },
        {
            title: localize(["DashboardMenus.account"]),
            requiredPermissions: [DASHBOARD_VIEWER],
            order: 4,
            children: [
                {
                    title: localize(["DashboardMenus.userManual"]),
                    event: "userManualEvent",
                    svgIcon: "DownloadNavSvg",
                    order: 80,
                    requiredPermissions: [DASHBOARD_VIEWER],
                },
                {
                    title: localize(["DashboardMenus.adminManual"]),
                    event: "adminManualEvent",
                    svgIcon: "DownloadNavSvg",
                    order: 80,
                    requiredPermissions: [USER_VIEW],
                },
                {
                    title: localize(["DashboardMenus.contactSupport"]),
                    event: "contactSupportEvent",
                    svgIcon: "HelpNavSvg",
                    order: 80,
                    requiredPermissions: [],
                },
                {
                    title: localize(["DashboardMenus.changePassword"]),
                    event: "changePasswordEvent",
                    svgIcon: "PreferencesNavSvg",
                    order: 80,
                    requiredPermissions: [],
                },
                {
                    title: localize(["DashboardMenus.changeNotificationSettings"]),
                    event: "changeNotificationSettingsEvent",
                    svgIcon: "PreferencesNavSvg",
                    order: 80,
                    requiredPermissions: [],
                },
                {
                    title: localize(["DashboardMenus.signOut"]),
                    event: "logoutEvent",
                    svgIcon: "SignOutNavSvg",
                    order: 80,
                    requiredPermissions: [],
                },
            ],
        },
    ],
};
export const getSortedMenus = () => {
    const menus = sidebarActions[DashboardType.Admin];
    const sorted = menus.sort((a, b) => (a.order > b.order ? 1 : -1));
    return sorted;
};
